import { render, staticRenderFns } from "./CharmIvr.vue?vue&type=template&id=2304bccb&scoped=true&"
import script from "./CharmIvr.vue?vue&type=script&lang=js&"
export * from "./CharmIvr.vue?vue&type=script&lang=js&"
import style0 from "./CharmIvr.vue?vue&type=style&index=0&id=2304bccb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2304bccb",
  null
  
)

export default component.exports